import { createAction } from '@reduxjs/toolkit'

export const catalogRefreshRequested = createAction<{ resourceId: string }>('aqsi/catalog/refreshRequested')
export const devicesRefreshRequested = createAction<{ resourceId: string }>('aqsi/catalog/devicesRefreshRequested')
export const fiscalCheckRequested = createAction<{ resourceId: string; deviceId: number; goodIds: readonly string[] }>(
  'aqsi/catalog/fiscalCheckRequested',
)
export const catalogReloadRequested = createAction<{ resourceId: string }>('aqsi/catalog/reloadRequested')

/** Результат проверки профиля живёт в кэше мутации под этим ключом — по rid, а не в слайсе. */
export const fiscalCheckCacheKey = (resourceId: string) => `aqsi-fiscal-check:${resourceId.toLowerCase()}`
